import { css } from "@emotion/css";

export const IntegrationStyle = css`
  width: 100%;
  max-width: 688px;
  margin: auto;
`;
